const CATALOG_ID_ALIASES = {
  awakened_awarenesss: 'awakened_awareness',
  barbecue_and_chilli: 'barbecue_chilli',
  darkness_revelated: 'darkness_revealed',
  face_the_darkness: 'hex_face_the_darkness',
  hive_mind: 'hex_hive_mind',
  nothing_but_misery: 'hex_nothing_but_misery',
  pentimento: 'hex_pentimento',
  monitor_and_abuse: 'monitor_abuse',
  flood_of_rage: 'scourge_hook_floods_of_rage',
  hangmans_trick: 'scourge_hook_hangman_s_trick',
  jagged_compass: 'scourge_hook_jagged_compass',
  monstrous_shrine: 'scourge_hook_monstrous_shrine',
  pain_resonance: 'scourge_hook_pain_resonance',
  boon_destroyer: 'shattered_hope'
}

const GAMEPLAY_ALIASES = {
  dying_light: 'cull_the_weak',
  hex_plaything: 'hex_fortune_s_fool',
  save_the_best_for_last: 'keep_them_waiting',
  deadlock: 'no_holds_barred',
  scourge_hook_gift_of_pain: 'scourge_hook_weeping_wounds',
  play_with_your_food: 'see_how_they_run'
}

const TYPE_TAGS = {
  generator_slowdown: new Set(['regression', 'regressionspeed', 'progressionpenalty', 'genblocker', 'repairingproficiency']),
  generator_trigger: new Set(['generator', 'generators']),
  generator_info: new Set([]),
  aura: new Set([]),
  information: new Set(['auras', 'auraflareup', 'killerinstinct', 'loudnoisenotification', 'loudnoisenotifications', 'notification', 'reveal', 'scream', 'screams']),
  tracking: new Set([]),
  chase_loop: new Set(['chase', 'pallets', 'palletblocker', 'windows', 'windowblocker', 'vaulting', 'vaultlocations', 'stunrecovery', 'breakablewalls']),
  chase_conversion: new Set(['haste', 'hindered', 'lunge', 'bloodlust', 'basicattacks', 'attackcooldown']),
  exposed: new Set(['exposed']),
  hex: new Set(['hex']),
  hex_support: new Set([]),
  endgame: new Set(['exitgates', 'gateblocker', 'gateswitchblocker']),
  anti_heal: new Set(['healingproficiency', 'self-healing', 'mangled', 'haemorrhage', 'hemorrhage', 'broken']),
  healing_info: new Set([]),
  hook: new Set(['hooks', 'hooking', 'scourgehooks', 'carrying', 'pickingup', 'unhooking', 'wiggle', 'basement', 'entityprogression']),
  scourge: new Set(['scourgehooks']),
  terror_radius: new Set(['terrorradius']),
  stealth: new Set(['undetectable', 'oblivious', 'terrorradiustransfer', 'stealth', 'deception']),
  exhaustion_control: new Set(['exhausted', 'exhaustion']),
  obsession: new Set(['obsession']),
  snowball: new Set(['dying', 'injuredstate', 'exposed', 'carrying']),
  basic_attack: new Set(['basicattacks', 'attackcooldown'])
}

const TYPE_OVERRIDES = {
  agitation: ['hook', 'snowball'],
  a_nurse_s_calling: ['aura', 'information', 'healing_info'],
  bloodhound: ['information', 'tracking'],
  stridor: ['information', 'tracking'],
  whispers: ['information', 'tracking'],
  mindbreaker: ['exhaustion_control', 'generator_trigger'],
  genetic_limits: ['exhaustion_control'],
  languid_touch: ['exhaustion_control', 'information'],
  discordance: ['generator_info', 'information'],
  surveillance: ['generator_info', 'information'],
  tinkerer: ['generator_info', 'information', 'stealth'],
  gearhead: ['generator_info', 'information', 'aura'],
  bitter_murmur: ['generator_info', 'information', 'aura'],
  eruption: ['generator_slowdown', 'generator_trigger', 'information', 'aura'],
  distressing: ['terror_radius'],
  unnerving_presence: ['terror_radius'],
  starstruck: ['terror_radius', 'exposed'],
  coulrophobia: ['terror_radius', 'anti_heal'],
  septic_touch: ['terror_radius', 'anti_heal'],
  monitor_abuse: ['terror_radius', 'stealth'],
  help_wanted: ['chase_conversion', 'basic_attack'],
  none_are_free: ['endgame', 'chase_conversion'],
  cull_the_weak: ['generator_slowdown', 'anti_heal', 'obsession'],
  dying_light: ['generator_slowdown', 'anti_heal', 'obsession'],
  hex_fortune_s_fool: ['hex', 'hex_support', 'hook', 'stealth'],
  hex_plaything: ['hex', 'hex_support', 'hook', 'stealth'],
  hex_undying: ['hex', 'hex_support', 'information', 'aura'],
  hex_thrill_of_the_hunt: ['hex', 'hex_support'],
  dominance: ['hex_support'],
  hex_pentimento: ['hex', 'hex_support', 'generator_slowdown'],
  hex_retribution: ['hex', 'hex_support', 'information', 'aura', 'stealth'],
  hex_haunted_ground: ['hex', 'hex_support', 'exposed'],
  keep_them_waiting: ['chase_conversion', 'obsession', 'basic_attack'],
  save_the_best_for_last: ['chase_conversion', 'obsession', 'basic_attack'],
  no_holds_barred: ['generator_slowdown'],
  deadlock: ['generator_slowdown'],
  scourge_hook_weeping_wounds: ['scourge', 'hook', 'anti_heal', 'generator_slowdown'],
  scourge_hook_gift_of_pain: ['scourge', 'hook', 'anti_heal', 'generator_slowdown'],
  see_how_they_run: ['chase_conversion', 'obsession'],
  play_with_your_food: ['chase_conversion', 'obsession']
}

const SURVIVOR_AURA_READERS = new Set([
  'alien_instinct',
  'a_nurse_s_calling',
  'awakened_awareness',
  'barbecue_chilli',
  'bitter_murmur',
  'blood_warden',
  'darkness_revealed',
  'eruption',
  'deerstalker',
  'friends_til_the_end',
  'gearhead',
  'grim_embrace',
  'hex_undying',
  'human_greed',
  'i_m_all_ears',
  'lethal_pursuer',
  'lightborn',
  'nowhere_to_hide',
  'phantom_fear',
  'predator',
  'nemesis',
  'hex_retribution',
  'scourge_hook_hangman_s_trick',
  'scourge_hook_floods_of_rage',
  'shattered_hope',
  'territorial_imperative',
  'thwack',
  'wandering_eye',
  'weave_attunement',
  'zanshin_tactics'
])

export const KILLER_BUILD_ARCHETYPES = [
  {
    id: 'balanced_toolkit',
    title: 'Balanced toolkit',
    summary: 'One tracking tool, one tempo tool and one chase conversion tool.',
    advantages: ['Covers the full match without stacking slowdown'],
    drawbacks: ['Less specialised than a dedicated package'],
    slots: [
      { id: 'tracking', types: ['information', 'aura'] },
      { id: 'tempo', types: ['generator_slowdown', 'hook', 'hex_support'] },
      { id: 'conversion', types: ['chase_loop', 'chase_conversion', 'exposed', 'snowball', 'anti_heal', 'stealth'] }
    ],
    anchorTypes: ['information', 'chase_loop', 'chase_conversion', 'hook'],
    preferredTypes: ['information', 'chase_loop', 'chase_conversion', 'hook'],
    maxGeneratorPerks: 1
  },
  {
    id: 'generator_control',
    title: 'Generator control',
    summary: 'A deliberate slowdown route with tracking and chase conversion around it.',
    advantages: ['Strong objective tempo', 'Still reserves one slot for conversion'],
    drawbacks: ['Less expressive and more dependent on regression events'],
    slots: [
      { id: 'slowdown_one', types: ['generator_slowdown'] },
      { id: 'slowdown_two', types: ['generator_slowdown'] },
      { id: 'conversion', types: ['chase_loop', 'chase_conversion', 'information', 'snowball'] }
    ],
    anchorTypes: ['generator_slowdown'],
    preferredTypes: ['generator_slowdown', 'generator_info', 'information'],
    maxGeneratorPerks: 2
  },
  {
    id: 'chase_conversion',
    title: 'Chase conversion',
    summary: 'Shortens loops and turns the first hit or pallet into a faster down.',
    advantages: ['Distinct chase-first playstyle', 'Low reliance on passive slowdown'],
    drawbacks: ['Demands consistent chase execution'],
    slots: [
      { id: 'loop_access', types: ['chase_loop'] },
      { id: 'hit_conversion', types: ['chase_conversion', 'basic_attack', 'exposed'] },
      { id: 'target_access', types: ['information', 'aura', 'stealth'] }
    ],
    anchorTypes: ['chase_loop', 'chase_conversion', 'basic_attack'],
    preferredTypes: ['chase_loop', 'chase_conversion', 'basic_attack', 'information'],
    maxGeneratorPerks: 1
  },
  {
    id: 'aura_hunter',
    title: 'Aura hunter',
    summary: 'Chains timed information into fast target acquisition and repeat chases.',
    advantages: ['High target uptime', 'Rewards killers that can convert information quickly'],
    drawbacks: ['Aura denial can reduce several slots at once'],
    slots: [
      { id: 'aura_one', types: ['aura'] },
      { id: 'aura_two', types: ['aura'] },
      { id: 'conversion', types: ['chase_loop', 'chase_conversion', 'snowball', 'stealth'] }
    ],
    anchorTypes: ['aura'],
    preferredTypes: ['aura', 'information', 'chase'],
    maxGeneratorPerks: 1
  },
  {
    id: 'hex_network',
    title: 'Hex network',
    summary: 'Builds a totem package with protection, cleanse punishment and a payoff.',
    advantages: ['Creates a genuinely different macro objective', 'Supports several hex packages'],
    drawbacks: ['Spawn locations and early cleanses add variance'],
    slots: [
      { id: 'hex_payoff', types: ['hex'] },
      { id: 'hex_support', types: ['hex_support'] },
      { id: 'conversion', types: ['information', 'chase_loop', 'chase_conversion', 'snowball', 'stealth'] }
    ],
    anchorTypes: ['hex'],
    preferredTypes: ['hex', 'hex_support', 'information', 'chase_conversion'],
    maxGeneratorPerks: 1
  },
  {
    id: 'endgame_trap',
    title: 'Endgame trap',
    summary: 'Preserves pressure for powered gates and forces one final dangerous phase.',
    advantages: ['Clear late-game identity', 'Offers alternatives to early slowdown'],
    drawbacks: ['Carries inactive slots before the final generators'],
    slots: [
      { id: 'gate_delay', types: ['endgame'] },
      { id: 'endgame_threat', types: ['endgame'] },
      { id: 'conversion', types: ['chase_loop', 'chase_conversion', 'information', 'snowball'] }
    ],
    anchorTypes: ['endgame'],
    preferredTypes: ['endgame', 'obsession', 'chase_loop', 'chase_conversion'],
    maxGeneratorPerks: 1
  },
  {
    id: 'stealth_obsession',
    title: 'Stealth and obsession',
    summary: 'Manipulates terror radius and obsession changes to create ambush windows.',
    advantages: ['Unpredictable target flow', 'Supports ambush and obsession mechanics'],
    drawbacks: ['More conditional than direct slowdown'],
    slots: [
      { id: 'stealth', types: ['stealth'] },
      { id: 'obsession', types: ['obsession'] },
      { id: 'conversion', types: ['chase_loop', 'chase_conversion', 'information', 'snowball'] }
    ],
    anchorTypes: ['stealth', 'obsession'],
    preferredTypes: ['stealth', 'obsession', 'chase_loop', 'chase_conversion'],
    maxGeneratorPerks: 1
  },
  {
    id: 'injury_pressure',
    title: 'Injury pressure',
    summary: 'Keeps several Survivors injured and punishes unsafe healing windows.',
    advantages: ['Creates snowball through interrupted resets', 'Works without a full regression package'],
    drawbacks: ['Loses value against efficient or scarce healing'],
    slots: [
      { id: 'anti_heal_one', types: ['anti_heal'] },
      { id: 'anti_heal_two', types: ['anti_heal'] },
      { id: 'reset_tracking', types: ['healing_info', 'information', 'aura', 'tracking', 'stealth'] }
    ],
    anchorTypes: ['anti_heal'],
    preferredTypes: ['anti_heal', 'healing_info', 'snowball', 'information'],
    maxGeneratorPerks: 1
  }
]

const TIMED_AURA_SOURCES = new Set([
  'alien_instinct',
  'barbecue_chili',
  'barbecue_and_chili',
  'barbecue_chilli',
  'bitter_murmur',
  'darkness_revealed',
  'eruption',
  'friends_til_the_end',
  'gearhead',
  'grim_embrace',
  'i_m_all_ears',
  'lethal_pursuer',
  'lightborn',
  'nowhere_to_hide',
  'phantom_fear',
  'predator',
  'nemesis',
  'hex_retribution',
  'human_greed',
  'scourge_hook_floods_of_rage',
  'shattered_hope',
  'territorial_imperative',
  'deerstalker',
  'thwack',
  'wandering_eye',
  'zanshin_tactics'
])

const CONTINUOUS_AURA_SOURCES = new Set([
  'a_nurse_s_calling',
  'awakened_awareness',
  'blood_warden',
  'hex_undying',
  'scourge_hook_hangman_s_trick',
  'weave_attunement'
])

function pairKey (firstId, secondId) {
  return [getKillerGameplayPerkId(firstId), getKillerGameplayPerkId(secondId)].sort().join('|')
}

function rule (firstId, secondId, kind, weight, reason, options) {
  return Object.assign({ firstId, secondId, kind, weight, reason, blocked: false }, options || {})
}

const EXPLICIT_PAIR_RULES = [
  rule('scourge_hook_pain_resonance', 'dead_man_s_switch', 'synergy', 100, 'Pain Resonance forces Survivors off the affected Generator after a hook, allowing Dead Man\'s Switch to block it.'),
  rule('spirit_fury', 'enduring', 'synergy', 100, 'Enduring shortens the Pallet stun while Spirit Fury destroys the Pallet that caused it.'),
  rule('hex_fortune_s_fool', 'hex_pentimento', 'synergy', 100, 'The personal Hexes encourage cleanses and leave broken Totems that Pentimento can rekindle.'),
  rule('franklin_s_demise', 'weave_attunement', 'synergy', 100, 'Franklin\'s Demise forces Items onto the ground, creating reliable Weave Attunement Aura zones.'),
  rule('agitation', 'starstruck', 'synergy', 100, 'Agitation expands the practical carrying route while Starstruck exposes Survivors inside the carried Terror Radius.'),
  rule('rancor', 'game_afoot', 'synergy', 98, 'Game Afoot can move the Obsession status to the chase target that Rancor threatens in the endgame.'),
  rule('no_way_out', 'remember_me', 'synergy', 98, 'Both perks extend the Exit Gate phase through different mechanics.'),
  rule('sloppy_butcher', 'a_nurse_s_calling', 'synergy', 96, 'Slower, less stable healing creates longer Aura-reading windows for A Nurse\'s Calling.'),
  rule('coulrophobia', 'distressing', 'synergy', 96, 'Distressing expands the Terror Radius in which Coulrophobia slows and disrupts healing.'),
  rule('infectious_fright', 'forced_hesitation', 'synergy', 94, 'Both perks convert a down into immediate nearby information and chase pressure.'),
  rule('hex_no_one_escapes_death', 'no_way_out', 'synergy', 94, 'No Way Out extends the powered-gate window in which No One Escapes Death is dangerous.'),
  rule('spirit_fury', 'hubris', 'synergy', 92, 'A Pallet stun can expose the Survivor with Hubris while Spirit Fury removes the Pallet.'),
  rule('enduring', 'hubris', 'synergy', 92, 'Enduring reduces the downtime after the stun that activates Hubris.'),
  rule('keep_them_waiting', 'rapid_brutality', 'synergy', 92, 'Both perks reward repeated Basic Attacks and shorten the time needed to reconnect in chase.'),
  rule('furtive_chase', 'friends_til_the_end', 'synergy', 92, 'Both perks rotate the Obsession through hooks and convert that rotation into tracking and tempo.'),
  rule('no_way_out', 'terminus', 'synergy', 90, 'No Way Out delays escape while Terminus keeps injured Survivors Broken during the gate phase.'),
  rule('no_way_out', 'blood_warden', 'synergy', 90, 'No Way Out delays gate access and Blood Warden can punish the later opening window.'),
  rule('agitation', 'awakened_awareness', 'synergy', 88, 'Agitation improves carrying mobility while Awakened Awareness identifies the next target.'),
  rule('coulrophobia', 'septic_touch', 'synergy', 88, 'Both effects punish healing inside the Terror Radius through different penalties.'),
  rule('bamboozle', 'superior_anatomy', 'synergy', 86, 'Both perks convert Survivor vaults into a faster Killer window route.'),
  rule('knock_out', 'deerstalker', 'independent', 20, 'Knock Out now hinders a Survivor after they leave a Pallet, while Deerstalker provides a separate timed Aura exchange; they no longer form a slug package.'),
  rule('agitation', 'mad_grit', 'synergy', 84, 'Agitation improves carrying movement while Mad Grit punishes body-block attempts.'),
  rule('agitation', 'iron_grasp', 'synergy', 82, 'Both perks extend reliable carrying routes, with diminishing value when stacked.'),
  rule('hex_huntress_lullaby', 'unnerving_presence', 'synergy', 82, 'Both perks pressure Healing and Repair Skill Checks through complementary timing changes.'),
  rule('hex_ruin', 'surveillance', 'synergy', 96, 'Hex: Ruin starts automatic Generator regression and Surveillance reports when Survivors interrupt that regression.'),
  rule('pop_goes_the_weasel', 'nowhere_to_hide', 'synergy', 92, 'One post-hook Generator kick spends Pop Goes the Weasel and triggers Nowhere to Hide around the kick location.'),
  rule('overcharge', 'nowhere_to_hide', 'synergy', 88, 'One Generator kick applies Overcharge and triggers Nowhere to Hide.'),
  rule('eruption', 'nowhere_to_hide', 'synergy', 86, 'One Generator kick prepares Eruption and immediately triggers Nowhere to Hide.'),
  rule('darkness_revealed', 'iron_maiden', 'synergy', 90, 'Iron Maiden speeds up Locker searches used to trigger Darkness Revealed.'),
  rule('sloppy_butcher', 'thanatophobia', 'synergy', 94, 'Sloppy Butcher makes healing slower and less stable, helping Thanatophobia keep several Survivors injured.'),
  rule('coulrophobia', 'a_nurse_s_calling', 'synergy', 90, 'A Nurse\'s Calling identifies healing inside the area where Coulrophobia can disrupt it.'),
  rule('monitor_abuse', 'a_nurse_s_calling', 'synergy', 88, 'The smaller out-of-chase Terror Radius helps approach Survivors revealed by A Nurse\'s Calling.'),
  rule('trail_of_torment', 'dragon_s_grip', 'synergy', 90, 'The same Generator kick creates Trail of Torment stealth and a trapped Generator that can expose its next toucher.'),
  rule('nemesis', 'see_how_they_run', 'synergy', 94, 'Nemesis creates a new Obsession after a Pallet stun, giving See How They Run a fresh target from whom to break chase.'),
  rule('hex_retribution', 'hex_haunted_ground', 'synergy', 96, 'Cleansing Haunted Ground both exposes the team and triggers Retribution\'s Aura reveal.'),
  rule('starstruck', 'awakened_awareness', 'synergy', 88, 'Starstruck exposes Survivors around the carried Terror Radius while Awakened Awareness identifies which exposed target to pursue.'),
  rule('mad_grit', 'iron_grasp', 'synergy', 86, 'Iron Grasp extends the carry window in which Mad Grit can punish body blocks.'),
  rule('knock_out', 'hex_the_third_seal', 'independent', 20, 'Knock Out no longer hides downed Survivors, so Third Seal does not extend its current Pallet-and-Hindered mechanic.'),
  rule('infectious_fright', 'distressing', 'synergy', 96, 'Distressing expands the Terror Radius used by Infectious Fright to detect nearby Survivors after a down.'),
  rule('starstruck', 'distressing', 'synergy', 96, 'Distressing expands the carried Terror Radius in which Starstruck exposes Survivors.'),
  rule('unnerving_presence', 'distressing', 'synergy', 92, 'Distressing expands the Terror Radius in which Unnerving Presence disrupts Skill Checks.'),
  rule('septic_touch', 'distressing', 'synergy', 90, 'Distressing expands the Terror Radius in which Septic Touch punishes healing.'),
  rule('lethal_pursuer', 'rancor', 'no_effect', 20, 'Rancor reveals positions with an Aura flare-up rather than a timed Survivor Aura, so Lethal Pursuer cannot extend it.'),
  rule('hex_ruin', 'pop_goes_the_weasel', 'conditional_conflict', 18, 'While Hex: Ruin is active, Generators regress automatically and cannot be kicked to activate Pop Goes the Weasel.'),
  rule('hex_ruin', 'nowhere_to_hide', 'conditional_conflict', 18, 'While Hex: Ruin is active, the Killer cannot kick a Generator to trigger Nowhere to Hide.'),
  rule('hex_ruin', 'overcharge', 'conditional_conflict', 18, 'While Hex: Ruin is active, the Killer cannot kick a Generator to apply Overcharge.'),
  rule('hex_ruin', 'call_of_brine', 'conditional_conflict', 18, 'While Hex: Ruin is active, the Killer cannot kick a Generator to apply Call of Brine.'),
  rule('hex_ruin', 'eruption', 'conditional_conflict', 18, 'While Hex: Ruin is active, the Killer cannot kick Generators to prepare Eruption.'),
  rule('hex_ruin', 'trail_of_torment', 'conditional_conflict', 18, 'While Hex: Ruin is active, the Killer cannot kick a Generator to activate Trail of Torment.'),
  rule('hex_ruin', 'unforeseen', 'conditional_conflict', 18, 'While Hex: Ruin is active, the Killer cannot kick a Generator to activate Unforeseen.'),
  rule('rapid_brutality', 'beast_of_prey', 'anti_synergy', 0, 'Rapid Brutality disables Bloodlust, which Beast of Prey requires to activate.', { blocked: true }),
  rule('scourge_hook_weeping_wounds', 'sloppy_butcher', 'redundancy', 30, 'Both perks can apply Mangled and Haemorrhage, so part of their anti-heal value overlaps.'),
  rule('grim_embrace', 'dead_man_s_switch', 'redundancy', 34, 'Both perks block Generators after hooks and can spend part of their duration at the same time.')
].reduce((lookup, entry) => {
  lookup[pairKey(entry.firstId, entry.secondId)] = entry
  return lookup
}, {})

export function getKillerCatalogPerkId (perkId) {
  return CATALOG_ID_ALIASES[perkId] || perkId
}

export function getKillerGameplayPerkId (perkOrId) {
  const rawId = typeof perkOrId === 'string' ? perkOrId : perkOrId && (perkOrId.gameplayId || perkOrId.id)
  const id = getKillerCatalogPerkId(rawId)
  return GAMEPLAY_ALIASES[id] || id
}

export function areKillerGameplayEquivalents (firstPerkOrId, secondPerkOrId) {
  const firstId = getKillerGameplayPerkId(firstPerkOrId)
  const secondId = getKillerGameplayPerkId(secondPerkOrId)
  return Boolean(firstId && secondId && firstId === secondId)
}

export function getKillerPerkGameplayTypes (perkOrId) {
  const id = getKillerGameplayPerkId(perkOrId)
  const sourceId = typeof perkOrId === 'string' ? perkOrId : perkOrId && perkOrId.id
  const tags = typeof perkOrId === 'string' ? [] : (perkOrId && perkOrId.tags) || []
  const normalizedTags = new Set(tags.map(tag => String(tag).toLowerCase()))
  const types = []
  Object.keys(TYPE_TAGS).forEach(type => {
    if (Array.from(TYPE_TAGS[type]).some(tag => normalizedTags.has(tag))) types.push(type)
  })
  if (SURVIVOR_AURA_READERS.has(id) || SURVIVOR_AURA_READERS.has(sourceId)) types.push('aura')
  ;(TYPE_OVERRIDES[id] || TYPE_OVERRIDES[sourceId] || []).forEach(type => {
    if (types.indexOf(type) === -1) types.push(type)
  })
  return types.length ? types : ['utility']
}

export function getKillerPerkPairRule (firstPerkOrId, secondPerkOrId) {
  const firstId = getKillerGameplayPerkId(firstPerkOrId)
  const secondId = getKillerGameplayPerkId(secondPerkOrId)
  if (!firstId || !secondId || firstId === secondId) return null
  const explicit = EXPLICIT_PAIR_RULES[pairKey(firstId, secondId)]
  if (explicit) return explicit

  const lethalTarget = firstId === 'lethal_pursuer' ? secondId : secondId === 'lethal_pursuer' ? firstId : null
  if (lethalTarget && TIMED_AURA_SOURCES.has(lethalTarget)) {
    return rule(firstId, secondId, 'synergy', 94, 'Lethal Pursuer extends this timed Survivor Aura reveal by 2 seconds.')
  }
  if (lethalTarget && CONTINUOUS_AURA_SOURCES.has(lethalTarget)) {
    return rule(firstId, secondId, 'no_effect', 20, 'Lethal Pursuer cannot extend this Aura reading because it is continuous or condition-held rather than timed.')
  }

  const firstTypes = getKillerPerkGameplayTypes(firstPerkOrId)
  const secondTypes = getKillerPerkGameplayTypes(secondPerkOrId)
  const hexSupportId = ['hex_undying', 'hex_thrill_of_the_hunt', 'dominance'].find(id => firstId === id || secondId === id)
  const otherTypes = firstId === hexSupportId ? secondTypes : firstTypes
  if (hexSupportId && otherTypes.indexOf('hex') !== -1) {
    const weights = { hex_undying: 92, dominance: 86, hex_thrill_of_the_hunt: 84 }
    return rule(firstId, secondId, 'synergy', weights[hexSupportId], `${hexSupportId.replace(/_/g, ' ')} protects or delays interaction with the paired Hex.`)
  }

  const pentimentoTarget = firstId === 'hex_pentimento' ? secondTypes : secondId === 'hex_pentimento' ? firstTypes : null
  if (pentimentoTarget && pentimentoTarget.indexOf('hex') !== -1) {
    return rule(firstId, secondId, 'synergy', 78, 'The paired Hex encourages a cleanse and leaves a broken Totem that Hex: Pentimento can rekindle.')
  }

  const retributionTarget = firstId === 'hex_retribution' ? secondTypes : secondId === 'hex_retribution' ? firstTypes : null
  if (retributionTarget && retributionTarget.indexOf('hex') !== -1) {
    return rule(firstId, secondId, 'synergy', 84, 'Cleansing the paired Hex also triggers Hex: Retribution\'s Survivor Aura reveal.')
  }

  const agitationTarget = firstId === 'agitation' ? secondTypes : secondId === 'agitation' ? firstTypes : null
  if (agitationTarget && agitationTarget.indexOf('scourge') !== -1) {
    return rule(firstId, secondId, 'synergy', 84, 'Agitation makes it more reliable to reach the required Scourge Hook before the carried Survivor escapes.')
  }
  return null
}

export function killerArchetypeById (archetypeId) {
  return KILLER_BUILD_ARCHETYPES.find(archetype => archetype.id === archetypeId) || KILLER_BUILD_ARCHETYPES[0]
}

export default KILLER_BUILD_ARCHETYPES
